/**
 * Generated by orval 🍺
 * Do not edit manually.
 * GTA CRM Demo API
 * GTA CRM 生产级 demo 的只读+轻写 API(feat-008;demo-scoped,零 model 零迁移)。
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `pending` - 待收
 * * `partially_paid` - 部分已收
 * * `paid` - 已收
 * * `overdue` - 逾期
 * * `waived` - 豁免
 */
export type WonReceiptPaymentStatusEnum =
  (typeof WonReceiptPaymentStatusEnum)[keyof typeof WonReceiptPaymentStatusEnum];

export const WonReceiptPaymentStatusEnum = {
  pending: "pending",
  partially_paid: "partially_paid",
  paid: "paid",
  overdue: "overdue",
  waived: "waived",
} as const;
